<div class="title">
  <i class="close-icon" mat-button cdkFocusInitial [mat-dialog-close]="false" (click)="closeDialog()"></i>
</div>

<div class="dialog-content">
  <div>{{ data.message }}</div>
  <div *ngIf="data.subMessage" class="additional-text" [class]="sizeOption">{{ data.subMessage }}</div>
</div>

<mat-dialog-actions>
  <ng-container *ngIf="data.showCancel; else twoButtons">
    <app-basic-button type="secondary" [size]="sizeOption" [mat-dialog-close]="'cancel'">{{ 'Cancel' | i18next }}</app-basic-button>
    <app-basic-button type="secondary" [size]="sizeOption" [mat-dialog-close]="'no'">{{ 'No' | i18next }}</app-basic-button>
    <app-basic-button type="primary" [size]="sizeOption" [mat-dialog-close]="'yes'">{{ 'Yes' | i18next }}</app-basic-button>
  </ng-container>
  <ng-template #twoButtons>
    <app-basic-button type="secondary" [size]="sizeOption" [mat-dialog-close]="false">{{ 'No' | i18next }}</app-basic-button>
    <app-basic-button type="primary" [size]="sizeOption" [mat-dialog-close]="true">{{ 'Yes' | i18next }}</app-basic-button>
  </ng-template>
</mat-dialog-actions>
